import { ProductUnit, ProductVariant } from '../../types/paloma-api-catalog'
import { WatchlistItem } from '../../types/paloma-api-customers'

export const getUnitCodeFromItem = (item: WatchlistItem) => {
  const unit = (item.variant as ProductVariant).units?.find(
    (productUnit: ProductUnit) => productUnit.unit === item.unit,
  )
  return unit?.unitCode || 'trade_unit'
}
